type SpinnerProps = {
  className?: string;
};

const Spinner = ({ className = "" }: SpinnerProps) => (
  <div className={`flex items-center justify-center py-10 ${className}`}>
    <div className="h-8 w-8 animate-spin rounded-full border-4 border-gray-200 border-t-primary" />
  </div>
);

export default Spinner;
